// @flow

import type { Action } from './store.type';

export const INTEGRATION_REQUEST = 'INTEGRATION_REQUEST';
type INTEGRATION_REQUEST_TYPE = 'INTEGRATION_REQUEST';

export const INTEGRATION_SUCCESS = 'INTEGRATION_SUCCESS';
type INTEGRATION_SUCCESS_TYPE = 'INTEGRATION_SUCCESS';

export const INTEGRATION_FAILURE = 'INTEGRATION_FAILURE';
type INTEGRATION_FAILURE_TYPE = 'INTEGRATION_FAILURE';

type IntegrationSuccess = {
  data: Object
};

type IntegrationFailure = {
  error: any
};

type IntegrationRequestAction = Action<INTEGRATION_REQUEST_TYPE, null>;

type IntegrationSuccessAction = Action<INTEGRATION_SUCCESS_TYPE, IntegrationSuccess>;

type IntegrationFailureAction = Action<INTEGRATION_FAILURE_TYPE, IntegrationFailure>;

export type IntegrationAction =
  | IntegrationRequestAction
  | IntegrationSuccessAction
  | IntegrationFailureAction;

export type IntegrationState = {
  loading: boolean,
  success: boolean,
  error: any
};
